// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import eventVenueEntity from './entities/event-venue.json';
import eventVenueMenu from '../pages/event-venue/menu.json';
import eventVenueFullForm from '../pages/event-venue/forms/full.json';
import eventVenueContextForm from '../pages/event-venue/forms/context.json';
import eventVenueMiniForm from '../pages/event-venue/forms/mini.json';
import eventVenueLookupForm from '../pages/event-venue/forms/lookup.json';
import eventVenueTableView from '../pages/event-venue/views/table.json';
import eventVenueDashboardView from '../pages/event-venue/views/dashboard.json';

/** Тип запису «Місце проведення» зі сторінками пакета: меню, форми та подання з pages/event-venue/. */
export const eventVenueDefinition: IRecordTypeDefinition = {
  ...eventVenueEntity,
  views: assembleViewSet({
      table: eventVenueTableView,
      dashboard: eventVenueDashboardView,
  }),
  form: eventVenueFullForm,
  forms: { full: eventVenueFullForm, context: eventVenueContextForm, mini: eventVenueMiniForm, lookup: eventVenueLookupForm },
  menu: eventVenueMenu,
} as IRecordTypeDefinition;
